import Vue from "vue";
import Vuex from 'vuex'
import Axios from 'axios'
Vue.use(Vuex)

const state = {
  isOpen:false,
  current: {
    uid: '',
    name: '',
    permissions:[]
  },
  userInfo:{
    LoginName:'',
    UserId:''
  }
}
const getters = {
  getNavState:(state)=>{
    return state.isOpen
  }
}
const mutations ={
  changeNavMutation(state){
   state.isOpen=!state.isOpen
  }
}
const actions={
  changeNavAction({state,commit}){
    commit('changeNavMutation')
  }
}
export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js